
<template>
  <div>
    <v-dialog 
      v-model="dialog" 
      scrollable 
      persistent 
      :overlay="true" 
      max-width="600px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Editando dados do Motorista</span>
        </v-card-title>
        <v-card-text>

          <v-form ref="form" lazy-validation>
            <v-col cols='12'>
              <v-col cols='12'>
                <v-radio-group  row v-model="driver_infos.kind">
                  <v-radio label="Motorista" :value="'driver'"></v-radio>
                  <v-radio label="Transportadora" :value="'transporter'"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols='12'>
                <v-text-field :rules="required" v-model="driver_infos.name" label="Nome" ></v-text-field>
              </v-col>
              <div v-if="driver_infos.kind == 'driver'">
                <v-col cols='12' >
                  <v-text-field :rules="[...required, validarCPF(driver_infos.cpf)]" v-model="driver_infos.cpf" label="CPF" v-mask="'###.###.###-##'"></v-text-field>
                </v-col>
                <v-col cols='12'>
                  <v-text-field key="cpf" :rules="required" v-model="driver_infos.cnh" label="CNH"></v-text-field>
                </v-col>
              </div>
              <div v-if="driver_infos.kind == 'transporter'">
                <v-col cols='12'>
                  <v-text-field key="cnpj" v-model="driver_infos.cnpj" label="CNPJ" v-mask="'##.###.###/####-##'" :rules="[...cnpj]"></v-text-field>
                </v-col>
              </div>
            </v-col>
          </v-form>

          <FileAttachment 
            class="ma-2" 
            :attached_file_url="driver.attached_file_url" 
            ref="attach" 
            :update_infos="{API: 'Driver', MODEL:'Driver', id: this.$route.params.id}"
            @newFileUrl="handleNewFileUrl"
          ></FileAttachment>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <f-btn close @click="closeDialog">Cancelar</f-btn>
          <f-btn save @click="updateInfos()">Salvar</f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-loading loadingText="Salvando" v-if="saving"></dialog-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from '@/mixins/validations'
import Api from '@/api/index';

export default {
  name: 'DialogEditDriverInfo',
  mixins: [ validations ],
  components: {
    FileAttachment: () => import("@/components/shared/FileAttachment.vue"),
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    driver: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      driver_infos: {
        id: null,
        name: '',
        cnh: '',
        cpf: '',
        kind:'',
        cnpj:''
      },
      saving: false,
    }
  },
  methods: {
    handleNewFileUrl(url){
      this.$emit('refresh')
    },
    closeDialog(){
      this.$emit('closeDialog', 'info')
    },  
    updateInfos(){
      if(this.$refs.form.validate()){
        this.saving = true
        let METHOD = this.$route.params.id ? 'updateInfos' : 'create'

        let { name, cnh, cpf, kind, cnpj } = this.driver_infos
        let driver = {name, cnh, cpf, kind, cnpj, id: this.$route.params.id}

        let success = false
        Api.Driver[METHOD](driver).then(r=> r.data).then(d=> {
          success = true
          this.addNotification({type: 'success',  msg: `Motorista 3º editado com sucesso!`})
        }).catch(err=>{
          console.log(err)
          this.addNotification({type: 'error',  msg: `As informações não foram atualizadas!`})
        }).finally(() => {
          this.saving = false
          if(success){this.$emit('refresh')};
          this.closeDialog()
        })
      }
    },
  },
  watch:{
    "driver_infos.kind"(nv){
      if(nv == "driver"){
        this.driver_infos.cnpj = ''
      }else{
        this.driver_infos.cpf = ''
        this.driver_infos.cnh = ''

      }
    }
  },
  mounted () {
    this.driver_infos = {
      id: this.$route.params.id,
      name: this.driver.name, 
      cpf: this.driver.cpf, 
      cnh: this.driver.cnh,
      kind: this.driver.kind,
      cnpj: this.driver.cnpj,
    };
  },
}
</script>
